<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 mb-3">
    <h1 class="h2">Bundle Types</h1>
</div>

<div *ngIf="loading">loading</div>

<app-table [dataSource]="bundleTypes" [displayedColumns]="displayedColumns" [route]="'route'" [checkBoxes]="true"
  *ngIf="!loading" (rowClick)="rowClick($event)" (deleteClick)="delete($event)" [clickToEdit]="false"
  (editClick)="edit($event)" (createClick)="add()" [permission]="permissions.BundleTypes" uniqueKey="bundle-types"></app-table>
